import { useIntl } from 'react-intl';

import { Input } from '@/components/ui/input';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';
import { useBudgetType } from '@/hooks/use-budget-type';

interface BudgetProps {
  label?: string;
}

export function Budget({ label }: BudgetProps) {
  const intl = useIntl();
  const { getEditCampaignBudgetLabel } = useBudgetType();
  const {
    hookForm,
    isFetching,
    campaign,
    setActiveEditField,
    isCompleted,
    isFree,
  } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;

  const {
    register,
    formState: { errors },
    watch,
  } = hookForm;

  const budgetType = watch('budget_type');

  return (
    <Input
      isNumber={!isFree}
      label={label ?? getEditCampaignBudgetLabel(budgetType)}
      {...register('budget', {
        setValueAs: value => (value === '' ? null : Number(value)),
      })}
      {...(isFree && {
        value: intl.formatMessage({
          defaultMessage: 'Free',
          description: 'Budget input value shown when the channel has no cost',
        }),
        className: '[&_input]:italic [&_input]:text-fx-neutral-600',
      })}
      {...(campaign?.contract_id != null && {
        value: intl.formatMessage({
          defaultMessage: 'Managed outside Fountain',
          description:
            'Budget input value shown when the channel is managed outside Fountain',
        }),
        className: '[&_input]:italic [&_input]:text-fx-neutral-600',
      })}
      placeholderLabel="$"
      placeholder={intl.formatMessage({
        defaultMessage: 'Enter budget',
        description: 'Placeholder for total or rate budget on edit campaign',
      })}
      error={errors.budget?.message}
      isFetching={isFetching}
      onFocus={() => setActiveEditField('budget')}
      onBlur={() => setActiveEditField(null)}
      readOnly={isCompleted || isReadonly || isFree}
    />
  );
}
